var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bjlsc"},[_c('headerBanner',{attrs:{"bannerUrl":_vm.domain+_vm.data.bgpic}}),_vm._v(" "),_c('div',{staticClass:"common_title clearfix"},[_c('p',[_vm._v(_vm._s(_vm.data.name))])]),_vm._v(" "),_c('div',{staticClass:"about_detail",domProps:{"innerHTML":_vm._s(_vm.data.content)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d75a18d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report.vue
// module id = 8wE5
// module chunks = 0